import { render, staticRenderFns } from "./Testing.vue?vue&type=template&id=3f9d1f47&scoped=true&"
import script from "./Testing.vue?vue&type=script&lang=js&"
export * from "./Testing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9d1f47",
  null
  
)

export default component.exports